import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { ButtonHTMLAttributes, FC } from "react";
import styled from "styled-components";
import { ThinArrowCircle } from "icons";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  // children?: ReactNode;
  className?: string;
  direction?: "left" | "right";
}

const Carousel4Button: FC<Props> = withErrorBoundary(({ className = "", onClick, direction = "left", ...props }) => {
  return (
    <StyledCarousel4Button
      className={cn(className, {
        Carousel3Button_right: direction === "right",
      })}
      type="button"
      onClick={onClick}
      {...props}
    >
      <ThinArrowCircle className="Carousel4__icon" />
    </StyledCarousel4Button>
  );
}, {});

const StyledCarousel4Button = styled.button`
  height: fit-content;
  flex-shrink: 0;
  line-height: 0;
  cursor: pointer;

  .Carousel4__icon {
    position: relative;
    width: 48px;
    height: 48px;

    :hover {
      opacity: 0.7;
    }
  }
`;

export { Carousel4Button };
